import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_XH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '033131b9-59c1-4326-a517-83465b60719c',
  ''
);
